module.exports = __webpack_public_path__ + "204e90dc7f4c04be440570830c88ce97.pdf";